import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { HistoTacheService } from './../../services/histotache.service';
import { TacheService } from './../../services/tache.service';
import { TypeTacheService } from './../../services/typeTache.service';
import { Component, OnInit } from '@angular/core';
import { Typetache } from '../../models/typetache.model';
import { Tache } from '../../models/tache.model';
import { TypeSalle } from '../../models/typesalle.model';
import { TypesalleService } from '../../services/typesalle.service';
import { Historiquetache } from '../../models/historiqueTache.model';

@Component({
  selector: 'app-tache',
  templateUrl: './tache.component.html',
  styleUrls: ['./tache.component.scss']
})
export class TacheComponent implements OnInit {
  typessalles: TypeSalle[];
  typeTaches: Typetache[];
  taches: Tache[];
  histoRes: Historiquetache[];
  constructor(private histotacheService: HistoTacheService,
              private translate: TranslateService,
              private tacheService: TacheService,
              private typeTacheService: TypeTacheService,
              private typesalleService: TypesalleService) {
    forkJoin(this.typesalleService.get_typessalles(),
             this.typeTacheService.get_typetache(),
             this.tacheService.get_taches(),
             this.histotacheService.get_histotaches())
    .subscribe((res: any) => {
      this.typessalles = res[0];
      this.typeTaches = res[1];
      this.taches = res[2];
      this.histoRes = res[3];
    });
  }
  async ngOnInit() {
  }

}
